const quizData = [
  {
    id: 1,
    question: "Who won the FIFA World Cup in 2022?",
    options: ["Germany", "Argentina", "France", "Brazil"],
    answer: 1, // Argentina
  },
  {
    id: 2,
    question: "Which club does Lionel Messi currently play for (2024)?",
    options: ["PSG", "Barcelona", "Inter Miami", "Man City"],
    answer: 2, // Inter Miami
  },
  {
    id: 3,
    question: "Which country hosted the 2018 FIFA World Cup?",
    options: ["Russia", "Qatar", "Germany", "South Africa"],
    answer: 0, // Russia
  },
  {
    id: 4,
    question: "Which player has the most Ballon d'Or wins?",
    options: ["Cristiano Ronaldo", "Lionel Messi", "Modric", "Ronaldinho"],
    answer: 1, // Messi
  },
  {
    id: 5,
    question: "Which country has won the most World Cups?",
    options: ["Italy", "Brazil", "Germany", "Argentina"],
    answer: 1, // Brazil
  },
  {
    id: 6,
    question: "Who is the current captain of the Indian football team?",
    options: [
      "Sunil Chhetri",
      "Gurpreet Singh",
      "Sahal Abdul",
      "Sandesh Jhingan",
    ],
    answer: 0, // Chhetri
  },
  {
    id: 7,
    question: "Which team won UEFA Champions League 2023?",
    options: ["Real Madrid", "Man City", "Liverpool", "Bayern"],
    answer: 1, // Man City
  },
  {
    id: 8,
    question: "Which footballer is known as 'The Pharaoh'?",
    options: ["Salah", "Zidane", "Hazard", "Drogba"],
    answer: 0, // Salah
  },
  {
    id: 9,
    question: "Which club has the most UCL titles?",
    options: ["Barcelona", "Man United", "Real Madrid", "AC Milan"],
    answer: 2, // Real Madrid
  },
  {
    id: 10,
    question: "Which Indian football club is based in Goa?",
    options: ["Kerala Blasters", "East Bengal", "FC Goa", "ATK Mohun Bagan"],
    answer: 2, // FC Goa
  },
];

export default quizData;
